import Vue from 'vue';
import i18n from "../../../i18n";

export default {
  async createActivity({ commit }, payload) {
    return Vue.axios.post(Vue.$url("activity"), payload)
      .then((rsp) => {
        Vue.$log.debug("actvity created and saved under", rsp.data.id);
        commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'Activity', 1: payload.description }), { root: true });
      })
  },

  async fetchNextMaxCode({ commit }, { pId, vId }) {
    Vue.$log.debug('fetching next code for', pId, vId);
    let query = '?pId=' + (pId || '') + '&vId=' + (vId || '');
    return Vue.axios.get(Vue.$url("activity/max-code" + query))
      .then((rsp) => {
        commit('SET_NEXT_SEQ_CODE', rsp.data)
        return rsp.data;
      })
  },

  async fetchActivities({ commit }, { pId, vId, pvId }) {
    Vue.$log.debug('fetching activities for', pId, vId);
    let query = '?pId=' + (pId || '') + '&vId=' + (vId || '') + '&pvId=' + (pvId || '');

    return Vue.axios.get(Vue.$url("activity" + query))
      .then((rsp) => {
        commit("SET_ACTIVITIES", rsp.data);
      })
  },

  async deleteActivity({ commit }, payload) {
    Vue.$log.debug('trying to delete activity', payload.id);
    return Vue.axios.delete(Vue.$url("activity/" + payload.id))
      .then(() => {
        commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }), { root: true });
      });
  },

  async updateActivity({ commit }, payload) {
    return Vue.axios.put(Vue.$url("activity/" + payload.id), payload)
      .then(() => {
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Activity', 1: payload.description }), { root: true });
      })
  },

  async updateActivityList({ commit }, payload) {
    Vue.$log.debug("Update xlsx", payload);

    let formData = new FormData();
    formData.append("file", payload.file);
    formData.append("pvId", payload.pvId);
    formData.append("resetOldValues", payload.resetOldValues);

    return await Vue.axios
      .post(Vue.$url(`activity/import`), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((rsp) => {
        commit("mShowInfoMessage", i18n.t("common.uploadmessage"), { root: true });
        return rsp.data;
      });
  },
}